<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a href="#" class="breadcrumb-item">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">›</span>
      <a href="#" class="breadcrumb-item">Events</a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-item active">Tournaments</span>
    </nav>

    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Tournaments</h1>
      <button class="btn btn-primary" (click)="openAddSidebar()">
        <svg viewBox="0 0 24 24" class="btn-icon">
          <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        Add tournament
      </button>
    </header>

    <!-- Success/Error Messages -->
    <div *ngIf="successMessage" class="alert alert-success">
      {{ successMessage }}
    </div>
    <div *ngIf="errorMessage" class="alert alert-error">
      {{ errorMessage }}
    </div>

    <!-- Content Card -->
    <div class="content-card">
      <!-- Table Header -->
      <div class="table-header">
        <div class="table-title-section">
          <h2 class="table-title">Tournaments list</h2>
          <span class="badge badge-blue">{{tournaments.length}}</span>
        </div>
        <div class="search-box">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search"
            class="search-input"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>
      </div>

      <!-- Table -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Tournament Name</th>
              <th>Sport</th>
              <th>Branch</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="7" style="text-align: center; padding: 2rem;">
                Loading tournaments...
              </td>
            </tr>
            <tr *ngIf="!isLoading && paginatedTournaments.length === 0">
              <td colspan="7" style="text-align: center; padding: 2rem;">
                No tournaments found.
              </td>
            </tr>
            <tr *ngFor="let tournament of paginatedTournaments; let i = index" class="table-row animate-fade-in clickable-row" (click)="viewTournament(tournament.id)">
              <td>
                <div class="tournament-info">
                  <div class="tournament-icon" [style.background]="getGradientColor(i)">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                  <div class="tournament-details">
                    <div class="tournament-name">{{tournament.name}}</div>
                    <div class="tournament-category">{{tournament.sport}}</div>
                  </div>
                </div>
              </td>
              <td>
                <span class="location-text">{{tournament.sport}}</span>
              </td>
              <td>
                <span class="location-text">{{tournament.branch}}</span>
              </td>
              <td>
                <span class="date-text">{{tournament.startDate | date: 'MMM d, y'}}</span>
              </td>
              <td>
                <span class="date-text">{{tournament.endDate | date: 'MMM d, y'}}</span>
              </td>
              <td>
                <span class="status-badge" [class]="'status-' + getStatus(tournament).toLowerCase()">
                  {{getStatus(tournament)}}
                </span>
              </td>
              <td>
                <div class="action-buttons" (click)="$event.stopPropagation()">
                  <button class="action-btn" title="View Details" (click)="viewTournament(tournament.id)">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
          Previous
        </button>
        <div class="pagination-numbers">
          <button
            *ngFor="let page of visiblePages"
            class="page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{page}}
          </button>
        </div>
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
          Next
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
      </div>
    </div>
  </main>

  <!-- Add Tournament Sidebar -->
  <div class="modal-overlay" *ngIf="showAddSidebar" (click)="closeAddSidebar()"></div>
  <div class="modal-container" *ngIf="showAddSidebar">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Add New Tournament</h2>
        <button class="close-btn" (click)="closeAddSidebar()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-error">
          {{ errorMessage }}
        </div>

        <div class="form-group">
          <label for="name">Tournament Name *</label>
          <input
            type="text"
            id="name"
            [(ngModel)]="tournamentForm.name"
            placeholder="Enter tournament name"
            class="form-control"
            [disabled]="isCreating"
          />
        </div>

        <div class="form-group">
          <label for="sport">Sport *</label>
          <select
            id="sport"
            [(ngModel)]="tournamentForm.sport"
            class="form-control"
            [disabled]="isCreating"
          >
            <option value="">Select a sport</option>
            <option *ngFor="let sport of sports" [value]="sport">{{ sport }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="branch">Branch *</label>
          <select
            id="branch"
            [(ngModel)]="tournamentForm.branch"
            class="form-control"
            [disabled]="isCreating"
          >
            <option value="">Select a branch</option>
            <option *ngFor="let branch of branches" [value]="branch.name">{{ branch.name }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="description">Description</label>
          <textarea
            id="description"
            [(ngModel)]="tournamentForm.description"
            placeholder="Enter tournament description"
            class="form-control"
            rows="3"
            [disabled]="isCreating"
          ></textarea>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="startDate">Start Date *</label>
            <input
              type="date"
              id="startDate"
              [(ngModel)]="tournamentForm.startDate"
              class="form-control"
              [disabled]="isCreating"
            />
          </div>

          <div class="form-group">
            <label for="endDate">End Date *</label>
            <input
              type="date"
              id="endDate"
              [(ngModel)]="tournamentForm.endDate"
              class="form-control"
              [disabled]="isCreating"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="maxTeams">Max Teams</label>
            <input
              type="number"
              id="maxTeams"
              [(ngModel)]="tournamentForm.maxTeams"
              placeholder="0"
              class="form-control"
              [disabled]="isCreating"
              min="0"
            />
          </div>

          <div class="form-group">
            <label for="maxIndividuals">Max Individuals</label>
            <input
              type="number"
              id="maxIndividuals"
              [(ngModel)]="tournamentForm.maxIndividuals"
              placeholder="0"
              class="form-control"
              [disabled]="isCreating"
              min="0"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="teamFee">Team Registration Fee (Regular)</label>
            <input
              type="number"
              id="teamFee"
              [(ngModel)]="tournamentForm.teamRegistrationFee"
              placeholder="0.00"
              class="form-control"
              [disabled]="isCreating"
              min="0"
              step="0.01"
            />
          </div>

          <div class="form-group">
            <label for="teamFeeAcademy">Team Registration Fee (Academy)</label>
            <input
              type="number"
              id="teamFeeAcademy"
              [(ngModel)]="tournamentForm.teamRegistrationFeeAcademy"
              placeholder="0.00"
              class="form-control"
              [disabled]="isCreating"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="individualFee">Individual Registration Fee (Regular)</label>
            <input
              type="number"
              id="individualFee"
              [(ngModel)]="tournamentForm.individualRegistrationFee"
              placeholder="0.00"
              class="form-control"
              [disabled]="isCreating"
              min="0"
              step="0.01"
            />
          </div>

          <div class="form-group">
            <label for="individualFeeAcademy">Individual Registration Fee (Academy)</label>
            <input
              type="number"
              id="individualFeeAcademy"
              [(ngModel)]="tournamentForm.individualRegistrationFeeAcademy"
              placeholder="0.00"
              class="form-control"
              [disabled]="isCreating"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="tournamentForm.showOnMobileHome"
              [disabled]="isCreating"
              class="form-checkbox"
            />
            <span>Show on mobile home screen</span>
          </label>
          <p class="form-hint">Enable this to display the tournament in the mobile app home slider</p>
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="tournamentForm.isTeamRegistrationEnabled"
              [disabled]="isCreating"
              class="form-checkbox"
            />
            <span>Enable team registration</span>
          </label>
          <p class="form-hint">Allow users to register as teams for this tournament</p>
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="tournamentForm.isIndividualRegistrationEnabled"
              [disabled]="isCreating"
              class="form-checkbox"
            />
            <span>Enable individual registration</span>
          </label>
          <p class="form-hint">Allow users to register as individuals for this tournament</p>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          (click)="closeAddSidebar()"
          [disabled]="isCreating"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary"
          (click)="createTournament()"
          [disabled]="isCreating || !tournamentForm.name || !tournamentForm.sport || !tournamentForm.branch"
        >
          <span *ngIf="!isCreating">Create Tournament</span>
          <span *ngIf="isCreating">Creating...</span>
        </button>
      </div>
    </div>
  </div>
</div>
